/**
 * Русский перевод
 * Russian Translation
 */

const ruRUTranslations = {
  app: {
    title: 'Инструмент управления сверхурочными',
    subtitle: 'Система управления сверхурочными',
    description: 'Профессиональный инструмент для учета сверхурочных и управления отгулами'
  },

  // Дата и время
  dateTime: {
    invalidDate: 'Недействительная дата',
    formatError: 'Ошибка формата даты'
  },

  common: {
    confirm: 'Подтвердить',
    cancel: 'Отмена',
    save: 'Сохранить',
    delete: 'Удалить',
    edit: 'Редактировать',
    copy: 'Копировать',
    close: 'Закрыть',
    loading: 'Загрузка...',
    success: 'Успешно',
    error: 'Ошибка',
    warning: 'Предупреждение',
    info: 'Информация',
    yes: 'Да',
    no: 'Нет',
    ok: 'ОК',
    back: 'Назад',
    next: 'Далее',
    previous: 'Предыдущий',
    submit: 'Отправить',
    reset: 'Сброс',
    clear: 'Очистить',
    search: 'Поиск',
    filter: 'Фильтр',
    sort: 'Сортировка',
    export: 'Экспорт',
    import: 'Импорт',
    settings: 'Настройки',
    help: 'Помощь',
    about: 'О программе'
  },
  
  time: {
    startTime: 'Время начала',
    endTime: 'Время окончания',
    duration: 'Продолжительность',
    totalTime: 'Общее время',
    remainingTime: 'Оставшееся время',
    usedTime: 'Использованное время',
    availableTime: 'Доступное время',
    hours: 'Часы',
    minutes: 'Минуты',
    days: 'Дни',
    today: 'Сегодня',
    yesterday: 'Вчера',
    thisWeek: 'На этой неделе',
    thisMonth: 'В этом месяце',
    thisYear: 'В этом году'
  },
  
  overtime: {
    title: 'Записи сверхурочных',
    record: 'Записать сверхурочные',
    startTime: 'Время начала сверхурочных',
    endTime: 'Время окончания сверхурочных',
    duration: 'Продолжительность сверхурочных',
    remaining: 'Оставшееся время отгула',
    total: 'Общие сверхурочные',
    list: 'Список записей сверхурочных',
    details: 'Подробные записи',
    consumption: 'Записи потребления',
    edit: 'Редактировать запись сверхурочных',
    delete: 'Удалить запись сверхурочных',
    copy: 'Копировать запись',
    
    validation: {
      startTimeRequired: 'Пожалуйста, введите время начала сверхурочных!',
      endTimeRequired: 'Пожалуйста, введите время окончания сверхурочных!',
      endTimeAfterStart: 'Время окончания сверхурочных должно быть после времени начала!'
    },
    
    stats: {
      totalHours: 'В этом году вы отработали {{hours}} сверхурочных часов',
      remainingHours: 'Оставшееся время отгула: {{overtimeHours}}+{{annualLeaveHours}} часов'
    }
  },
  
  rest: {
    title: 'Записи отгулов',
    record: 'Запросить отгул',
    startTime: 'Время начала отгула',
    endTime: 'Время окончания отгула',
    duration: 'Продолжительность отгула',
    type: 'Тип отгула',
    compTime: 'Компенсационное время',
    list: 'Список записей отгулов',
    edit: 'Редактировать запись отгула',
    delete: 'Удалить запись отгула',
    
    validation: {
      startTimeRequired: 'Пожалуйста, введите время начала и окончания отгула!',
      endTimeRequired: 'Пожалуйста, введите время окончания отгула!',
      endTimeAfterStart: 'Время окончания отгула должно быть после времени начала!',
      insufficientTime: 'Недостаточно оставшегося времени для этого запроса отгула!',
      insufficientOvertimeTime: 'Недостаточно сверхурочных часов для увеличения компенсационного времени!'
    }
  },
  
  annualLeave: {
    title: 'Управление ежегодным отпуском',
    totalDays: 'Общие дни ежегодного отпуска',
    usedHours: 'Использованные часы',
    remainingHours: 'Оставшиеся часы',
    record: 'Записи ежегодного отпуска',
    set: 'Установить ежегодный отпуск',
    edit: 'Редактировать запись ежегодного отпуска',
    delete: 'Удалить запись ежегодного отпуска',
    
    settings: {
      title: 'Установить ежегодный отпуск',
      totalDaysLabel: 'Общие дни ежегодного отпуска',
      totalDaysPlaceholder: 'Введите общие дни ежегодного отпуска',
      note: 'Примечание: Ежегодный отпуск рассчитывается как 8 часов в день'
    }
  },
  
  rules: {
    title: 'Правила расчета',
    overtime: {
      title: 'Правила расчета сверхурочных',
      description: 'Рассчитывается по непрерывному времени, включая обеденный перерыв',
      example: 'Пример: {{timeRange}} = {{result}}',
      note: 'Сверхурочные рассчитываются по фактическому непрерывному времени, обеденный перерыв не вычитается'
    },
    rest: {
      title: 'Правила расчета отгулов',
      description: 'Рассчитывается по рабочим дням, обеденный перерыв вычитается',
      example: 'Пример: {{timeRange}} = {{result}} ({{note}})',
      note: '1 час обеденного перерыва вычитается',
      workingHours: 'Рабочие часы: 9:00-18:00 (исключая 12:00-13:00 обеденный перерыв)'
    },
    annualLeave: {
      title: 'Правила расчета ежегодного отпуска',
      description: 'Ежегодный отпуск рассчитывается как 8 часов в день',
      example: '1 день ежегодного отпуска = 8 часов'
    }
  },
  
  data: {
    save: 'Сохранить данные локально',
    load: 'Загрузить резервные данные',
    export: 'Экспорт данных',
    import: 'Импорт данных',
    backup: 'Резервное копирование данных',
    restore: 'Восстановить данные',
    clear: 'Очистить данные',
    
    messages: {
      saveSuccess: 'Данные успешно сохранены',
      loadSuccess: 'Данные успешно импортированы и обновлены',
      exportSuccess: 'Данные успешно экспортированы',
      importSuccess: 'Данные успешно импортированы',
      clearSuccess: 'Данные успешно очищены',
      parseError: 'Невозможно разобрать импортированный файл. Убедитесь, что он в правильном формате.',
      newerDataWarning: 'Импортированные данные старше локальных данных. Вы все еще хотите перезаписать локальные данные?',
      cleanupComplete: 'Очистка завершена, удалено {{count}} избыточных записей.'
    }
  },
  
  table: {
    index: 'Индекс',
    number: '№',
    type: 'Тип',
    startTime: 'Время начала',
    endTime: 'Время окончания',
    duration: 'Продолжительность',
    remaining: 'Оставшееся',
    remainingTime: 'Оставшееся время отгула',
    actions: 'Действия',
    details: 'Подробные записи',
    expand: 'Развернуть',
    collapse: 'Свернуть',
    noData: 'Нет данных',
    consumptionRecords: 'Записи потребления отгулов',
    restRequestStartTime: 'Время начала запроса отгула',
    restRequestEndTime: 'Время окончания запроса отгула',
    actualConsumptionStartTime: 'Фактическое время начала',
    actualConsumptionEndTime: 'Фактическое время окончания',
    deductionTime: 'Время вычета',
    annualLeaveStartTime: 'Время начала отпуска',
    annualLeaveEndTime: 'Время окончания отпуска',

    pagination: {
      total: 'Всего {{total}} элементов',
      pageSize: 'Элементов на странице',
      items: 'элементов',
      page: 'страница'
    }
  },
  
  consumption: {
    title: 'Записи потребления отгулов',
    restStartTime: 'Время начала запроса отгула',
    restEndTime: 'Время окончания запроса отгула',
    actualStartTime: 'Фактическое время начала потребления',
    actualEndTime: 'Фактическое время окончания потребления',
    deductionTime: 'Время вычета отгула',
    type: 'Тип',
    
    copyReport: {
      overtimeDeduction: 'Вычтены соответствующие сверхурочные часы ({{hours}} часов)',
      annualLeaveDeduction: 'Вычтены часы ежегодного отпуска ({{hours}} часов)',
      copySuccess: 'Скопировано в буфер обмена',
      copyFailed: 'Копирование не удалось, попробуйте еще раз'
    }
  },
  
  updateLog: {
    title: 'Журнал обновлений',
    show: 'Показать журнал обновлений',
    hide: 'Скрыть журнал обновлений',
    version: 'Версия',
    date: 'Дата',
    content: 'Содержание обновления'
  },
  
  language: {
    title: 'Настройки языка',
    current: 'Текущий язык',
    select: 'Выбрать язык',
    change: 'Изменить язык'
  },
  
  errors: {
    networkError: 'Ошибка сети, проверьте подключение',
    serverError: 'Ошибка сервера, попробуйте позже',
    unknownError: 'Неизвестная ошибка, обратитесь к администратору',
    validationError: 'Ошибка валидации данных',
    permissionDenied: 'Доступ запрещен',
    notFound: 'Данные не найдены',
    timeout: 'Тайм-аут запроса, попробуйте еще раз'
  },
  
  confirmDialog: {
    deleteTitle: 'Подтвердить удаление',
    deleteMessage: 'Вы уверены, что хотите удалить эту запись?',
    clearTitle: 'Подтвердить очистку',
    clearMessage: 'Вы уверены, что хотите очистить избыточные данные? Это действие нельзя отменить.',
    overwriteTitle: 'Подтвердить перезапись',
    overwriteMessage: 'Локальные данные будут перезаписаны, вы уверены, что хотите продолжить?',
    deleteRestMessage: 'Вы уверены, что хотите удалить эту запись отдыха?',
    deleteAnnualLeaveMessage: 'Вы уверены, что хотите удалить эту запись ежегодного отпуска?'
  },

  // Записи
  records: {
    overtimeRecords: 'Записи сверхурочных',
    restRecords: 'Записи отдыха',
    annualLeaveRecords: 'Записи ежегодного отпуска',
    restType: 'Отдых',
    annualLeaveType: 'Ежегодный отпуск',
    annualLeave: 'Ежегодный отпуск',
    rest: 'Отдых',
    overtime: 'Сверхурочные'
  },

  // Пагинация
  pagination: {
    previous: 'Предыдущая',
    next: 'Следующая',
    pageInfo: 'Страница {{current}} из {{total}}',
    itemsPerPage: '{{count}} записей/страница'
  },



  // Копирование
  copy: {
    deductOvertimeTotal: 'Отгул за сверхурочные, вычтено сверхурочных часов ({{hours}} часов)',
    deductAnnualLeaveTotal: 'Вычтены часы ежегодного отпуска ({{hours}} часов)',
    annualLeaveTitle: 'Ежегодный отпуск:',
    errorPrefix: 'Не удается скопировать текст: '
  },

  // Статистика
  stats: {
    totalOvertime: 'Общее время рабочего скота',
    availableOvertime: 'Доступное время рабочего скота',
    remainingAnnualLeave: 'Оставшееся большое время отдыха',
    totalRest: 'Общее время безделья'
  },

  // Действия
  actions: {
    recordOvertime: 'Записать событие рабочего скота',
    addOvertimeTime: 'Добавить запись рабочего скота',
    requestRest: 'Запросить безделье',
    useOvertimeTime: 'Начать бездельничать~~',
    setAnnualLeave: 'Установить большое время отдыха',
    configureAnnualLeaveDays: 'Настроить годовое большое время отдыха',
    recordAnnualLeave: 'Записать большое время отдыха',
    saveData: 'Сохранить записи рабочего скота',
    exportData: 'Экспортировать записи рабочего скота',
    importData: 'Импортировать записи рабочего скота',
    cleanData: 'Очистить дублирующие записи рабочего скота'
  },

  // Сообщения
  messages: {
    overtimeAdded: 'Запись рабочего скота добавлена',
    restAdded: 'Запись безделья добавлена',
    overtimeDeleted: 'Запись рабочего скота удалена',
    restDeleted: 'Запись безделья удалена',
    dataSaved: 'Данные сохранены',
    dataLoaded: 'Данные загружены',
    dataImported: 'Данные импортированы',
    dataExported: 'Данные экспортированы',
    noLocalData: 'Локальные данные не найдены, используются данные по умолчанию',
    cleanupComplete: 'Очистка завершена, удалено {{count}} избыточных записей',
    overtimeRecordAdded: 'Запись сверхурочных успешно добавлена!',
    restRequestSubmitted: 'Заявка на отдых успешно подана!',
    pleaseCompleteTimeInfo: 'Пожалуйста, заполните информацию о времени',
    overtimeRecordUpdated: 'Запись сверхурочных успешно обновлена!',
    restRecordUpdated: 'Запись отдыха успешно обновлена!',
    annualLeaveRecordUpdated: 'Запись ежегодного отпуска успешно обновлена!',
    copiedToClipboard: 'Скопировано в буфер обмена',
    copyFailed: 'Копирование не удалось, попробуйте еще раз'
  },

  // Модальные окна
  modals: {
    recordOvertimeTitle: 'Записать сверхурочные',
    requestRestTitle: 'Запросить отдых',
    setAnnualLeaveTitle: '🏖️ Установить дни ежегодного отпуска',
    editOvertimeTitle: 'Редактировать запись сверхурочных',
    editRestTitle: 'Редактировать запись отдыха',
    editAnnualLeaveTitle: 'Редактировать запись ежегодного отпуска',
    recordOvertimeTimeTitle: '⏱️ Записать сверхурочное время',
    requestRestTimeTitle: '😴 Запросить время отдыха'
  },

  // Формы
  forms: {
    currentAnnualLeave: 'Текущий ежегодный отпуск:',
    remainingTime: 'Оставшееся время:',
    customDays: 'Пользовательские дни:',
    enterDays: 'Введите дни',
    noAnnualLeave: 'Нет ежегодного отпуска',
    annualLeaveStartTime: 'Время начала ежегодного отпуска:',
    annualLeaveEndTime: 'Время окончания ежегодного отпуска:',
    overtimeStartTime: 'Время начала сверхурочных:',
    overtimeEndTime: 'Время окончания сверхурочных:'
  },

  // Тема
  theme: {
    toggle: 'Переключить тему',
    modern: 'Современный стиль',
    retro: 'Ретро стиль',
    sketch: 'Стиль эскиза',
    damaged: 'Боевой стиль',
    switchToModern: 'Переключиться на современный стиль',
    switchToRetro: 'Переключиться на ретро стиль',
    switchToSketch: 'Переключиться на стиль эскиза',
    switchToDamaged: 'Переключиться на боевой стиль'
  }
};

export default ruRUTranslations;
